import { UserManager, UserManagerSettings, WebStorageStateStore, Log } from 'oidc-client-ts';

Log.setLevel(Log.DEBUG);

// Override with REACT_APP_BASE_URL when using a tunnel (e.g. ngrok) for iframe login:
//   REACT_APP_BASE_URL=https://abc123.ngrok-free.app yarn start
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://localhost:3000';

export const settings: UserManagerSettings = {
    authority: 'https://janus.eu.authz.cloudentity.io/janus/demo',
    client_id: '5db70ee5e0444f8f88b7acd396a685cc',
    redirect_uri: `${BASE_URL}/popupCallback`,
    response_type: 'code',
    scope: 'openid profile say-nothing say-hello offline_access',
    automaticSilentRenew: false,
    popup_redirect_uri: `${BASE_URL}/popupCallback`,
    popup_post_logout_redirect_uri: `${BASE_URL}/logoutCallback`,
    post_logout_redirect_uri: `${BASE_URL}/logoutCallback`,
    silent_redirect_uri: `${BASE_URL}/popupCallback`,
    filterProtocolClaims: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    accessTokenExpiringNotificationTimeInSeconds: 300,
    metadataSeed: {
      end_session_endpoint: 'https://janus.eu.authz.cloudentity.io/janus/demo/logout'
    }
  };

export const client = new UserManager(settings);

client.events.addAccessTokenExpiring(async () => {
  console.log('Access token is expiring');

  const user = await client.getUser();
  if (user?.refresh_token) {
    console.log('Refreshing access token using refresh token');
    await client.signinSilent(); 
  } else {
    console.warn('No refresh token available, user needs to sign in again');
  }
});